import { NgModule } from '@angular/core';

import { CommonModule } from './../common/common.module';
import { CoreModule } from '../core/core.module';
import { MessageRoutingModule } from './message-routing.module';

import { MailService } from './service/data/mail.service';
import { SendTenantMailCommandHandler } from './service/command/send-tenant-mail-command-handler.service';

import { LetterFormComponent } from './component/letter-form-component/letter-form-component.component';
import {
  MailManagerComponent,
  PostManagerComponent,
  SmsManagerComponent,
  EmailManagerComponent,
} from './component/object-manager/mail-manager.component';
import { SendTenantMailsFormComponent } from './component/send-tenant-mails-form/send-tenant-maisl-form.component';
import { SendTenantMailsComponent } from './component/send-tenant-mails/send-tenant-mails.component';
import { PostFormComponent } from './component/post-form/post-form.component';
import { PostService } from './service/data/post.service';
import { SendTenantSMSCommandHandler } from './service/command/send-tenant-sms-command-handler.service';
import { SendTenantSMSFormComponent } from './component/send-tenant-sms-form/send-tenant-sms-form.component';
import { SendTenantSmsComponent } from './component/send-tenant-sms/send-tenant-sms.component';
import { SmsService } from './service/data/sms.service';
import { EmailService } from './service/data/email.service';
import { SendTenantEmailCommandHandler } from './service/command/send-tenant-email-command-handler.service';
import { SendTenantEmailsComponent } from './component/send-tenant-emails/send-tenant-emails.component';
import { SendTenantEmailFormComponent } from './component/send-tenant-email-form/send-tenant-email-form.component';
import { SendSingleNewEmailFormComponent } from './component/send-single-new-email-form/send-single-new-email-form.component';
import { SmsFormComponent } from './component/sms-form/sms-form.component';
import { EmailFormComponent } from './component/email-form/email-form.component';
import { SendGenericEmailFormComponent } from './component/send-generic-email-form/send-generic-email-form.component';

@NgModule({
  imports: [CommonModule, CoreModule],
  declarations: [
    LetterFormComponent,
    MailManagerComponent,
    PostFormComponent,
    PostManagerComponent,
    SmsFormComponent,
    SmsManagerComponent,
    EmailManagerComponent,
    EmailFormComponent,
    SendGenericEmailFormComponent,
    SendSingleNewEmailFormComponent,
    SendTenantEmailsComponent,
    SendTenantMailsComponent,
    SendTenantSmsComponent,
    SendTenantEmailFormComponent,
    SendTenantMailsFormComponent,
    SendTenantSMSFormComponent,
  ],
  providers: [
    EmailService,
    MailService,
    PostService,
    SmsService,
    SendTenantEmailCommandHandler,
    SendTenantMailCommandHandler,
    SendTenantSMSCommandHandler,
  ],
  exports: [],
})
export class MessageModule {}
